export function Hero() {
  return (
		<div id="hero" className="max-w-7xl mx-auto bg-gradient-to-br from-blue-600 to-blue-200 relative overflow-hidden h-[670px]">
			<div className="absolute inset-0 opacity-10">
				<div className="absolute top-20 left-10 w-32 h-32 bg-white rounded-full blur-xl animate-pulse">
				</div>
			<div className="absolute top-40 right-20 w-24 h-24 bg-white rounded-full blur-lg animate-bounce">
				</div>
			<div className="absolute bottom-32 right-1/3 w-20 h-20 bg-white rounded-full blur-md animate-pulse">
			</div>
			</div>
			<div className="absolute inset-0 opacity-15">
				<div className="absolute top-10 left-32 animate-spin" >
				<svg width="150" height="150" className="transform rotate-12">
				<circle cx="75" cy="75" r="65" fill="none" stroke="white" stroke-width="12" stroke-dasharray="130 280" stroke-linecap="round">
				</circle>
			<circle cx="75" cy="75" r="65" fill="none" stroke="white" stroke-width="12" stroke-dasharray="100 310" stroke-linecap="round" transform="rotate(90 75 75)">
				</circle>
			<circle cx="75" cy="75" r="65" fill="none" stroke="white" stroke-width="12" stroke-dasharray="60 350" stroke-linecap="round" transform="rotate(180 75 75)">
				</circle>
			</svg>
			</div>
			<div className="absolute top-16 right-16 flex items-end space-x-3">
				<div className="w-6 h-24 bg-white rounded-t animate-pulse" >
				</div>
			<div className="w-6 h-16 bg-white rounded-t animate-pulse" >
				</div>
			<div className="w-6 h-32 bg-white rounded-t animate-pulse" >
				</div>
			<div className="w-6 h-12 bg-white rounded-t animate-pulse" >
				</div>
			<div className="w-6 h-28 bg-white rounded-t animate-pulse" >
				</div>
			<div className="w-6 h-20 bg-white rounded-t animate-pulse" >
				</div>
			</div>
			<div className="absolute top-1/3 left-1/4 animate-bounce" >
			<svg width="180" height="120" className="transform -rotate-12">
				<path d="M20 100 L50 60 L80 70 L110 40 L140 50 L170 30" stroke="white" stroke-width="4" fill="none" stroke-linecap="round">
				</path>
			<circle cx="20" cy="100" r="4" fill="white" className="animate-ping" >
				</circle>
			<circle cx="50" cy="60" r="4" fill="white" className="animate-ping" >
				</circle>
			<circle cx="80" cy="70" r="4" fill="white" className="animate-ping" >
				</circle>
			<circle cx="110" cy="40" r="4" fill="white" className="animate-ping" >
				</circle>
			<circle cx="140" cy="50" r="4" fill="white" className="animate-ping" >
				</circle>
			<circle cx="170" cy="30" r="4" fill="white" className="animate-ping" >
				</circle>
			</svg>
			</div>
			<div className="absolute bottom-20 left-20 animate-spin" >
				<svg width="130" height="130" className="transform rotate-45">
				<circle cx="65" cy="65" r="55" fill="none" stroke="white" stroke-width="16" stroke-dasharray="110 240">
				</circle>
			<circle cx="65" cy="65" r="55" fill="none" stroke="white" stroke-width="16" stroke-dasharray="80 270" stroke-dashoffset="-110">
				</circle>
			<circle cx="65" cy="65" r="55" fill="none" stroke="white" stroke-width="16" stroke-dasharray="60 290" stroke-dashoffset="-190">
				</circle>
			</svg>
			</div>
			<div className="absolute top-2/3 right-4 animate-pulse" >
			<svg width="200" height="140" className="transform rotate-6">
				<defs>
				<linearGradient id="areaGradient" x1="0%" y1="0%" x2="0%" y2="100%">
				<stop offset="0%" stop-color="white" stop-opacity="0.6">
				</stop>
			<stop offset="100%" stop-color="white" stop-opacity="0.1">
				</stop>
			</linearGradient>
			</defs>
			<path d="M20 120 L50 80 L80 60 L110 45 L140 55 L170 35 L180 40 L180 120 Z" fill="url(#areaGradient)" stroke="white" stroke-width="3">
				</path>
			</svg>
			</div>
			<div className="absolute top-80 right-1/3 animate-bounce" >
			<svg width="80" height="80" className="transform -rotate-30">
				<polygon points="40,10 65,25 65,45 40,60 15,45 15,25" fill="none" stroke="white" stroke-width="3">
				</polygon>
			</svg>
			</div>
			<div className="absolute bottom-10 right-1/4 animate-pulse" >
			<svg width="100" height="100" className="transform rotate-12">
				<polygon points="50,15 85,75 15,75" fill="none" stroke="white" stroke-width="4">
				</polygon>
			</svg>
			</div>
			<div className="absolute top-1/2 right-8 animate-bounce" >
			<svg width="120" height="80" className="transform -rotate-6">
				<circle cx="20" cy="60" r="6" fill="white" className="animate-ping" >
				</circle>
			<circle cx="40" cy="30" r="8" fill="white" className="animate-ping" >
				</circle>
			<circle cx="70" cy="50" r="5" fill="white" className="animate-ping" >
				</circle>
			<circle cx="90" cy="20" r="7" fill="white" className="animate-ping" >
				</circle>
			<circle cx="110" cy="40" r="6" fill="white" className="animate-ping" >
				</circle>
			</svg>
			</div>
			</div>
			<div className="relative z-10 container mx-auto px-6 py-20">
				<div className="grid lg:grid-cols-2 gap-12 items-center min-h-[80vh]">
				<div className="text-white space-y-8">
				<h1 className="text-5xl lg:text-6xl font-bold leading-tight">Une plateforme qui<span className="block">s'adapte à votre</span>
			<span className="block">organisation</span>
			</h1>
			<p className="text-xl text-purple-100 leading-relaxed max-w-lg">Personnalisez vos pages, formulaires et actions pour une gestion plus rapide, plus simple et plus efficace.</p>
			</div>
			<div className="relative">
				<div className="bg-white rounded-2xl shadow-2xl p-6 transform rotate-3 hover:rotate-1 transition-transform duration-300">
				<div className="flex items-center justify-between mb-6">
				<div className="flex items-center space-x-2">
				<div className="w-3 h-3 bg-red-400 rounded-full">
				</div>
			<div className="w-3 h-3 bg-yellow-400 rounded-full">
				</div>
			<div className="w-3 h-3 bg-green-400 rounded-full">
				</div>
			</div>
			<div className="text-sm text-gray-500">OUTILS INFORMATIQUES Rapides &amp; Intelligents</div>
			</div>
			<div className="grid grid-cols-4 gap-4 mb-6">
				<div className="bg-yellow-50 p-3 rounded-lg text-center">
				<div className="text-orange-500 font-bold">8532</div>
			<div className="text-xs text-gray-600">Kwt</div>
			</div>
			<div className="bg-green-50 p-3 rounded-lg text-center">
				<div className="text-green-500 font-bold">393</div>
			<div className="text-xs text-gray-600">€</div>
			</div>
			<div className="bg-blue-50 p-3 rounded-lg text-center">
				<div className="text-blue-500 font-bold">57</div>
			<div className="text-xs text-gray-600">€</div>
			</div>
			<div className="bg-gray-50 p-3 rounded-lg text-center">
				<div className="text-gray-500 font-bold">0</div>
			<div className="text-xs text-gray-600">€</div>
			</div>
			</div>
			<div className="flex space-x-2 mb-6">
				<button className="bg-green-500 text-white px-3 py-1 rounded text-sm whitespace-nowrap">✓</button>
			<button className="bg-blue-500 text-white px-3 py-1 rounded text-sm whitespace-nowrap">✎</button>
			<button className="bg-red-500 text-white px-3 py-1 rounded text-sm whitespace-nowrap">✕</button>
			</div>
			<div className="grid grid-cols-2 gap-4 mb-4">
				<div className="bg-green-100 p-4 rounded-lg">
				<div className="text-green-800 font-semibold mb-2">Factures</div>
			<div className="space-y-2">
				<div className="bg-white p-2 rounded text-xs">Facture #001</div>
			<div className="bg-white p-2 rounded text-xs">Facture #002</div>
			</div>
			</div>
			<div className="bg-blue-100 p-4 rounded-lg">
				<div className="text-blue-800 font-semibold mb-2">Rapports</div>
			<div className="space-y-2">
				<div className="bg-white p-2 rounded text-xs">Rapport Mensuel</div>
			<div className="bg-white p-2 rounded text-xs">Rapport Ventes</div>
			</div>
			</div>
			</div>
			<div className="grid grid-cols-2 gap-4">
				<div className="bg-gray-50 p-3 rounded-lg">
				<div className="text-xs text-gray-600 mb-2">Analyses</div>
			<div className="h-16 bg-gradient-to-r from-blue-200 to-purple-200 rounded">
				</div>
			</div>
			<div className="bg-gray-50 p-3 rounded-lg">
				<div className="text-xs text-gray-600 mb-2">Performance</div>
			<div className="flex space-x-1 items-end h-16">
				<div className="bg-orange-300 w-2 h-8 rounded-t">
				</div>
			<div className="bg-yellow-300 w-2 h-12 rounded-t">
				</div>
			<div className="bg-green-300 w-2 h-6 rounded-t">
				</div>
			<div className="bg-blue-300 w-2 h-10 rounded-t">
				</div>
			</div>
			</div>
			</div>
			</div>
			<div className="absolute -right-8 top-80 bg-white rounded-lg shadow-xl p-4 w-64 transform -rotate-3 hover:-rotate-1 transition-transform duration-300">
				<div className="space-y-3">
				<div className="text-xs text-gray-500">Statistiques</div>
			<div className="space-y-2">
				<div className="flex justify-between text-xs">
				<span>Ventes</span>
			<span className="font-bold">89%</span>
			</div>
			<div className="flex justify-between text-xs">
				<span>Commandes</span>
			<span className="font-bold">67%</span>
			</div>
			<div className="flex justify-between text-xs">
				<span>Revenus</span>
			<span className="font-bold">94%</span>
			</div>
			</div>
			<div className="bg-gray-100 h-16 rounded flex items-center justify-center">
				<i className="ri-map-pin-line text-gray-400 text-xl">
				</i>
			</div>
			</div>
			</div>
			</div>
			</div>
			</div>
			</div>
    // <div className="pt-20 bg-gradient-to-b from-blue-200 to-white" id="hero">
    //   <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-20">
    //     <div className="text-center">
    //       <h1 className="text-5xl font-bold text-gray-900 mb-6">
    //         Gérez votre entreprise en toute simplicité
    //       </h1>
    //       <p className="text-xl text-gray-600 mb-8 max-w-3xl mx-auto">
    //         EvisionCRM vous aide à piloter votre activité, gérer vos clients et développer votre chiffre d'affaires.
    //       </p>
    //       {/* <div className="flex flex-col sm:flex-row justify-center gap-4">
    //         <button className="bg-blue-600 text-white px-8 py-4 rounded-full hover:bg-blue-700 transition-colors flex items-center justify-center">
    //           Démarrer l'essai gratuit ✅
    //           <ArrowRight className="ml-2" size={20} />
    //         </button>
    //         <button className="border-2 border-blue-600 text-blue-600 px-8 py-4 rounded-full hover:bg-blue-50 transition-colors">
    //           Voir la démo
    //         </button>
    //       </div> */}
    //     </div>

    //     {/* <div className="mt-20 grid grid-cols-1 md:grid-cols-3 gap-8"> */}
    //       {/* <div className="bg-white p-6 rounded-xl shadow-lg">
    //         <div className="bg-blue-100 w-12 h-12 rounded-lg flex items-center justify-center mb-4">
    //           <BarChart2 className="text-blue-600" size={24} />
    //         </div>
    //         <h3 className="text-xl font-semibold mb-2">Pilotage en temps réel</h3>
    //         <p className="text-gray-600">Suivez vos indicateurs clés et prenez les bonnes décisions.</p>
    //       </div> */}
          
    //       {/* <div className="bg-white p-6 rounded-xl shadow-lg">
    //         <div className="bg-blue-100 w-12 h-12 rounded-lg flex items-center justify-center mb-4">
    //           <Users className="text-blue-600" size={24} />
    //         </div>
    //         <h3 className="text-xl font-semibold mb-2">Gestion des contacts</h3>
    //         <p className="text-gray-600">Centralisez et organisez votre base clients efficacement.</p>
    //       </div> */}
          
    //       {/* <div className="bg-white p-6 rounded-xl shadow-lg">
    //         <div className="bg-blue-100 w-12 h-12 rounded-lg flex items-center justify-center mb-4">
    //           <Calendar className="text-blue-600" size={24} />
    //         </div>
    //         <h3 className="text-xl font-semibold mb-2">Planification</h3>
    //         <p className="text-gray-600">Gérez vos rendez-vous et tâches en un clin d'œil.</p>
    //       </div> */}
    //     {/* </div> */}
    //   </div>
    // </div>
  );
}